import { Component } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-gallery-viewer',
  templateUrl: './gallery-viewer.component.html',
  styleUrl: './gallery-viewer.component.scss'
})
export class GalleryViewerComponent {
  constructor(public localService: LocalService, config: NgbCarouselConfig) {
    config.interval = 5000;
    config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.localService.galleryViewUrl = [];
      } break;
    }
  }
}
